module.exports = __webpack_public_path__ + "static/media/ntakos_full1.26c2d5eb.jpg";